import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { policyNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const PolicyNumber = ({ t, policyNumberValid, validatePolicyNumber, policyNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { policyNumber } = useSelector((state) => state.app)

  const handlePolicyNumber = (e) => {
    try {
      let number = e.currentTarget.value.replace(/\s/g, '').toUpperCase()
      dispatch(policyNumberAction(number))
      //validatePolicyNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validatePolicyNumber(policyNumber)
  }

  const handleOnPaste = (e) => {
    e.preventDefault()
    return false
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            policyNumberValid === true
              ? policyNumber === ''
                ? ''
                : 'form-group has-success'
              : policyNumberValid === false
              ? 'form-group ns-form-group-message-error'
              : ''
          }
        >
          <label className="control-label" htmlFor="PolicyNumber">
            <b>{t('insurance_information.policy_number')}</b>
          </label>
          {policyNumberValid === false && (
            <div className="ns-form-error-container has-error error-msg-align">
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(policyNumberError)}</div>
            </div>
          )}
          <input
            style={{ width: '300px' }}
            type="text"
            className={['form-control', styles['field_width']].join(' ')}
            id="PolicyNumber"
            //onBlur={handleOnBlur}
            value={policyNumber}
            autoComplete="off"
            onChange={handlePolicyNumber}
            onFocus={() => SetIsFocussed(true)}
            onPaste={handleOnPaste}
            maxLength="50"
          />
          {policyNumberValid === true && policyNumber !== '' && (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(PolicyNumber)
